// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import { hocify } from '@zapier/legacy-components';

import * as Plan from 'app/entities/Plan';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import TeamsPricing from 'app/team/components/TeamsPricing';
import maybeRender from 'app/common/components/maybeRender';

import type { Dispatch } from 'app/common/types';

const mapStateToProps = (state, ownProps: { interval?: string }) => {
  const findPriceToDisplay = interval => {
    if (interval === 'year') {
      const annualPlan = Plan.selectors.all.findAnnualTeamPlan(state);
      return annualPlan && Plan.selectors.formattedAmountPerMonth(annualPlan);
    }

    const monthlyPlan = Plan.selectors.all.findMonthlyTeamPlan(state);
    return (
      (monthlyPlan && Plan.selectors.formattedAmountPerMonth(monthlyPlan)) ||
      null
    );
  };

  const currentPlan = Plan.selectors.all.currentPlan(state);
  const isAnnual = Plan.selectors.isAnnual(currentPlan);
  const currentInterval = currentPlan && !isAnnual ? 'month' : 'year';
  const interval = ownProps.interval || currentInterval;

  return {
    price: findPriceToDisplay(interval),
    isAnnual: interval === 'year',
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onLoad() {
    dispatch(Plan.actions.loadOwnOrDefaultPlans());
  },
});

export default _.flowRight(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  hocify(LoadingBlockOrComponent),
  // `price` may be empty if there's no plans data, like if there
  // are no team plans in a plan group (shouldn't happen) or if
  // a team _member_ is trying to load plan data (they can't).
  maybeRender(props => !!props.price)
)(TeamsPricing);
